<template>
    <el-drawer :title="formData.id ? '编辑取值' : '增加取值'" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="auto" @close="close">
        <div class="drawer-content" v-loading="dataLoading">
            <div><span class="el-icon-collection-tag"></span>标签：{{label}}</div>
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium" class="MT20">
                <el-form-item prop="symbol">
                    <span slot="label">代表符号：<small>一旦取值创建成功，代表符号不允许修改编辑</small></span>
                    <el-input v-model="formData.symbol" maxlength="10" show-word-limit :disabled="formData.id ? true : false"></el-input>
                </el-form-item>
                <el-form-item prop="actualMeaning" label="实际含义：">
                    <el-input v-model="formData.actualMeaning" maxlength="40" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="boundaryValue" label="判断值：">
                    <el-input v-model="formData.boundaryValue" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="remark" label="备注:">
                    <el-input v-model="formData.remark" type="textarea" maxlength="100" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultData = {
    actualMeaning: "",
    labelId: "",
    remark: "",
    symbol: "",
    boundaryValue: ""
}
export default {
    props: {
        labelId: {
            type: [String,Number],
            default: ""
        },
        label:{
            type: String,
            default: ""
        }
    },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData: {
                ...defaultData
            },
            rules: {
                symbol: [{ required: true, message: "请填写代表符号" }],
                actualMeaning: [{ required: true, message: "请填写实际含义" }],
            },
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.formData = {
                ...defaultData
            }
            this.drawerShow = false;
        },
        show(id) {
            if (id) {
                this.formData.id = id;
                this.getData();
            }
            this.drawerShow = true;
        },
        getData() {
            this.dataLoading = true;
            this.$request({
                url: '/label/value/detail',
                params: { id: this.formData.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.formData = {
                            ...this.formData,
                            ...result
                        }
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/label/value/edit',
                        data: { ...this.formData, labelId: this.labelId },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>